export interface IBaseControllerProps {}

export interface IBaseRouteArguments {}

export interface IBaseControllerRenderResult<T extends any> {
    hasEnoughDataToRender: boolean;
    suggestedAlternativeRoute?:
        | 'Launch'
        | 'LanguageSelect'
        | 'TourSelect'
        | 'Tour'
        | 'SiteObject'
        | 'FloorPlan';
    additionalRouteDataNeeded?: T;
}

export enum DataCheckResult {
    Undef = 0,
    DataAvailableOffline = 1,
    DataNetworkConnectionNeeded = 2,
    LastValue = 3,
}

export interface IBaseController<R extends IBaseRouteArguments, T extends IBaseControllerProps> {
    renderer: (args: T) => JSX.Element;
    canRender: (route: R) => Promise<IBaseControllerRenderResult<any>>;
    canLoad: (route: R) => Promise<DataCheckResult>;
}
